import { cliente } from '@/lib/cliente';
import type {
  ActualizarDensidadRequest,
  CrearDensidadRequest,
  DensidadMaterial,
  ListaDensidadesResponse,
  RespuestaApi,
} from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

/** Catálogo de densidades; cambia con poca frecuencia → cache 10 min. */
export function useDensidades() {
  return useQuery<RespuestaApi<ListaDensidadesResponse>>({
    queryKey: ['densidades-materiales'],
    queryFn: () => cliente.densidades.listar(),
    staleTime: 10 * 60 * 1000,
  });
}

export function useCrearDensidad() {
  const qc = useQueryClient();
  return useMutation<RespuestaApi<DensidadMaterial>, Error, CrearDensidadRequest>({
    mutationFn: (body) => cliente.densidades.crear(body),
    onSuccess: (r) => {
      if (r.data) {
        toast.success(`Densidad "${r.data.nombre}" agregada`);
        qc.invalidateQueries({ queryKey: ['densidades-materiales'] });
      } else {
        toast.error(r.error?.mensaje ?? 'Error desconocido');
      }
    },
    onError: (e) => toast.error('No se pudo agregar la densidad', { description: e.message }),
  });
}

export function useActualizarDensidad() {
  const qc = useQueryClient();
  return useMutation<
    RespuestaApi<DensidadMaterial>,
    Error,
    { clave: string } & ActualizarDensidadRequest
  >({
    mutationFn: ({ clave, ...body }) => cliente.densidades.actualizar(clave, body),
    onSuccess: (r) => {
      if (r.data) {
        toast.success('Densidad actualizada');
        qc.invalidateQueries({ queryKey: ['densidades-materiales'] });
      } else {
        toast.error(r.error?.mensaje ?? 'Error desconocido');
      }
    },
    onError: (e) => toast.error('No se pudo actualizar la densidad', { description: e.message }),
  });
}
